/* Promo Eye Patch 10 pares -> 1x KESSER Pepitide Lip Oil grátis (16/10/2026 – 20/10/2026 12:00 America/Sao_Paulo; datas vêm de KESSER_EP_GIFT). */
(function () {
  var C = window.KESSER_EP_GIFT || {};
  var GIFT = Number(C.giftVariantId || 0);
  var EYE = Number(C.eyePatchVariantId || 0);
  var START = Date.parse(C.startsAt), END = Date.parse(C.endsAt);
  var PROP = '_kesser_ep_gift';
  var depth = 0, queue = Promise.resolve(), unavailable = C.giftAvailable === false;
  var SOLD_KEY = 'kesser_ep_gift_soldout';
  try { var so = Number(sessionStorage.getItem(SOLD_KEY) || 0); if (so && Date.now() - so < 10 * 60 * 1000) unavailable = true; } catch (e) {}
  var addFailAt = 0;
  function markUnavailable() { unavailable = true; try { sessionStorage.setItem(SOLD_KEY, String(Date.now())); } catch (e) {} }

  function now() {
    // Test-only override: never honored on the live theme.
    try {
      var tid = Number((window.Shopify && Shopify.theme && Shopify.theme.id) || window.KESSER_THEME_ID || 0);
      var o = localStorage.getItem('kesser_ep_now');
      if (o && tid && tid !== Number(C.liveThemeId)) return Date.parse(o);
    } catch (e) {}
    return Date.now();
  }
  function active() { var n = now(); return n >= START && n <= END; }
  function fromLp() {
    try { if (sessionStorage.getItem('kesser_ep_lp') === '1') return true; } catch (e) {}
    return /(?:^|;\s*)kesser_ep_lp=1/.test(document.cookie);
  }
  function props(it) { var p = it.properties || {}; return Array.isArray(p) ? {} : p; }
  function isGiftLine(it) { return GIFT && Number(it.variant_id) === GIFT; }
  function isPaidEye(it) { return Number(it.variant_id) === EYE && !isGiftLine(it); }

  async function call(url, body) {
    depth++;
    try {
      var r = await fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } });
      if (!r.ok) { var e = new Error('cart ' + r.status); e.status = r.status; throw e; }
      return r.json();
    } finally { depth--; }
  }
  var getCart = function () { return call('/cart.js'); };

  function eligible(cart) {
    return !!GIFT && active() && fromLp() && !unavailable && cart.items.some(isPaidEye);
  }

  async function sync() {
    if (!GIFT) return null;
    var cart = await getCart();
    var gifts = cart.items.filter(isGiftLine);
    var changed = false;
    if (!eligible(cart)) {
      if (gifts.length) {
        var u = {}; gifts.forEach(function (g) { u[g.key] = 0; });
        cart = await call('/cart/update.js', { updates: u }); changed = true;
      }
    } else {
      var keep = gifts.find(function (g) { return String(props(g)[PROP]) === '1'; }) || gifts[0];
      var u2 = {}, n = 0;
      gifts.forEach(function (g) { if (g !== keep) { u2[g.key] = 0; n++; } });
      if (keep && keep.quantity !== 1) { u2[keep.key] = 1; n++; }
      if (n) { cart = await call('/cart/update.js', { updates: u2 }); changed = true; }
      if (!keep && Date.now() - addFailAt > 30000) {
        try {
          await call('/cart/add.js', { items: [{ id: GIFT, quantity: 1, properties: { [PROP]: '1', _kesser_gift_tier: 'Eye Patch 10 pares' } }] });
          changed = true;
        } catch (e) {
          // Sold out / not found: stop trying (no retry loop) and never block checkout.
          if (e.status === 422 || e.status === 404) markUnavailable(); else addFailAt = Date.now();
          console.warn('EP gift add failed', e);
        }
        cart = await getCart();
        if (unavailable) {
          var stale = cart.items.filter(isGiftLine);
          if (stale.length) {
            var u3 = {}; stale.forEach(function (g) { u3[g.key] = 0; });
            try { cart = await call('/cart/update.js', { updates: u3 }); changed = true; } catch (e2) { console.warn('EP gift stale remove failed', e2); }
          }
        }
      }
    }
    if (changed) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      try { if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kesser-ep-gift', cartData: cart }); } catch (e) {}
    }
    return cart;
  }
  function enqueue() { queue = queue.then(sync).catch(function (e) { console.warn('EP gift sync', e); }); return queue; }

  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  // Wait until the gift is in the cart when the cart qualifies. Resolves ok:true when the gift is present,
  // the cart does not qualify, the gift is confirmed unavailable (422/404/Liquid), or after maxMs.
  async function ensure(maxMs) {
    var deadline = Date.now() + (maxMs || 9000), cart = null;
    while (true) {
      addFailAt = 0;
      cart = await enqueue();
      if (!cart) { try { cart = await getCart(); } catch (e) { cart = null; } }
      if (cart) {
        if (unavailable || !eligible(cart)) return { ok: true, cart: cart, reason: unavailable ? 'unavailable' : 'not-eligible' };
        if (cart.items.some(isGiftLine)) return { ok: true, cart: cart, reason: 'gift-present' };
      }
      if (Date.now() >= deadline) { console.warn('EP gift ensure timeout'); return { ok: true, cart: cart, reason: 'timeout' }; }
      await sleep(700);
    }
  }

  // Checkout gate (called by kesser-auto-gift.js before checkout).
  async function harden() {
    var res = await ensure(9000);
    var cart = res.cart || (GIFT ? await getCart() : null);
    if (!cart) return { ok: true };
    var gifts = cart.items.filter(isGiftLine);
    // Never block because the gift is missing or unavailable. Only block when an extra/free
    // gift line remains that we could not remove while the gift is still purchasable.
    if (unavailable || !gifts.length) return { ok: true, cart: cart };
    var qty = gifts.reduce(function (n, g) { return n + Number(g.quantity || 0); }, 0);
    var ok = eligible(cart) ? qty <= 1 : false;
    return { ok: ok, cart: cart };
  }
  window.KesserEPGift = { sync: enqueue, ensure: ensure, harden: harden, eligible: eligible, active: active };
  if (!GIFT) return;

  var of = window.fetch;
  window.fetch = async function () {
    var res = await of.apply(this, arguments);
    var u = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    if (depth === 0 && /\/cart\/(add|change|update|clear)(\.js)?/.test(u)) setTimeout(enqueue, 50);
    return res;
  };
  document.addEventListener('cart:updated', function () { if (!depth) enqueue(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) enqueue(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enqueue); else enqueue();
  setInterval(enqueue, 8000);
})();
